// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../../BundleResourceConfig";
import LotteryItemBase from "../common/LotteryItemBase";
import { ChengYiKind } from "./data/ChengYiKind";

const {ccclass, property} = cc._decorator;

@ccclass
export default class GoldFlowerItemBase extends LotteryItemBase {

    @property(cc.Sprite)
    sprCard: cc.Sprite = null;

    private cardData: number = 0;
    // onLoad () {}

    start () {
        this.initUI();
    }

    setData(
        cardData: number
    ) {
        this.cardData = cardData;
        if (this.isInit()) {
            this.initUI();
        }
    }

    resetData() {
        this.bOpenShow = false;
        let children = this.judgeNode.children;
        for(let i = children.length-1; i >= 0; i--) {
            let nodeItem = children[i];
            nodeItem.active = true;
        }
    }

    initUI() {
        this.sprCard.node.active = false;

        let cardTypeData = ChengYiKind.CardTypeInfoArr[this.cardData];
        let path = "res/chengYi/" + cardTypeData.icon;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.lotteryBundle).load(path, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    this.sprCard.node.active = true;
                    this.sprCard.spriteFrame = imgs;
                }
            }
        );
    }
    // update (dt) {}
}
